import React from 'react';

import { appConfig } from '../../../../../appConfig';
import { useProductSearchStateContext } from '../../../../search/hooks/useProductSearchStateContext';

const SearchOverlayFooter = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{}>>(
    (props, ref) => {
        const { result, status, error } = useProductSearchStateContext();

        const hasError = !!error || status === 'error';
        const hasResults = !!result && result.items.length > 0;

        return (
            <div ref={ref}>
                {hasError ? (
                    <div className="u-textCenter u-paddingA">
                        <h1 className="Heading Heading--h3 u-textWeightNormal u-marginAz">
                            {appConfig.coopSettings.ecommerce.errorMessage.general}
                        </h1>
                    </div>
                ) : (
                    hasResults && <div>{props.children}</div>
                )}
            </div>
        );
    },
);

export default SearchOverlayFooter;
